module.exports = __webpack_public_path__ + "img/btn_menu_ljsf.e051910d.png";